import request from '@/utils/request'

export function getOrderList(params) {
  return request({
    url: '/admin/recharge/order/list',
    method: 'get',
    params
  })
}

export function rechargeBalance(data) {
  return request({
    url: '/admin/recharge/balance',
    method: 'post',
    data
  })
}

export function getOrderStatistics() {
  return request({
    url: '/admin/recharge/statistics',
    method: 'get'
  })
}

export function getRechargeCardList(params) {
  return request({
    url: '/admin/recharge-card/list',
    method: 'get',
    params
  })
}

export function createRechargeCard(data) {
  return request({
    url: '/admin/recharge-card',
    method: 'post',
    data
  })
}

export function updateRechargeCard(data) {
  return request({
    url: '/admin/recharge-card',
    method: 'put',
    data
  })
}

export function deleteRechargeCard(id) {
  return request({
    url: '/admin/recharge-card/' + id,
    method: 'delete'
  })
}

export function publishRechargeCard(id) {
  return request({
    url: '/admin/recharge-card/publish/' + id,
    method: 'put'
  })
}

export function invalidateRechargeCard(id) {
  return request({
    url: '/admin/recharge-card/invalidate/' + id,
    method: 'put'
  })
}

export function getRechargeCardUsers(id, params) {
  return request({
    url: '/admin/recharge-card/' + id + '/users',
    method: 'get',
    params
  })
}

export function refundOrder(data) {
  return request({
    url: '/admin/recharge/refund',
    method: 'post',
    data
  })
}

export function deleteOrder(tradeNo) {
  return request({
    url: '/admin/recharge/order/' + tradeNo,
    method: 'delete'
  })
}

/* ── 爱豆套餐（充值档位） ────────────────────────────── */

export function getBeanPackageList() {
  return request({
    url: '/admin/bean-package/list',
    method: 'get'
  })
}

export function createBeanPackage(data) {
  return request({
    url: '/admin/bean-package',
    method: 'post',
    data
  })
}

export function updateBeanPackage(id, data) {
  return request({
    url: '/admin/bean-package/' + id,
    method: 'put',
    data
  })
}

export function publishBeanPackage(id) {
  return request({
    url: '/admin/bean-package/' + id + '/publish',
    method: 'put'
  })
}

export function disableBeanPackage(id) {
  return request({
    url: '/admin/bean-package/' + id + '/disable',
    method: 'put'
  })
}

export function deleteBeanPackage(id) {
  return request({
    url: '/admin/bean-package/' + id,
    method: 'delete'
  })
}

